import kr from '../kr/kr';
import Swiper from 'swiper/bundle';

export default class Slider extends kr.Component {
    init() {
        const swiper = new Swiper('.js-Slider', {
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    }
}

kr.registerComponent('.js-Slider', {
    component: Slider
});